import {
  Box,
  ColumnLayout,
  Grid,
  Link,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import * as awsui from "@cloudscape-design/design-tokens";
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { CustomButton } from "../../../components/buttons";




export default function Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);

  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const screenWidth_600 = useMediaQuery({query: "only screen and (max-width : 600px)"})
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const screenWidth_1000 = useMediaQuery({query: "only screen and (max-width : 1000px)"})

  return (
    <>
      <center>
        <div style={{
          background: "none", 
          width: "100%", 
          paddingTop: "50px", 
          paddingBottom: screenWidth_600? "20px" : "50px"
        }}>
          <div data-trinations-series className="body-content">
            <Box>
              <div style={{
                maxWidth: screenWidth_600? "100%": "80%"
              }}>
                <img 
                  src="/images/trinations/tri-nations-logo-dark.png"
                  style={{
                    width: "100%"
                  }}
                />            
                <div style={{
                  textAlign: "left", 
                  fontSize: screenWidth_600? "1.2rem": "1.8rem", 
                  lineHeight: "40px", 
                  marginTop: "30px", 
                  color: awsui.colorTextBodySecondary
                }}>
                  <div style={{display: "flex", width: "100%", justifyContent: "space-evenly"}}>
                    <div style={{textAlign: "center"}}>
                      QUALIFYING<br />
                      23RD & 30TH JULY
                    </div>
                    <div style={{textAlign: "center"}}>
                      RACE<br />
                      6TH AUGUST
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundItemSelected, width: "100%", paddingTop: "20px", paddingBottom: "0px"}}>
          <div data-trinations-series className="body-content">
            <div style={{paddingTop: "10px", paddingBottom: "40px"}}>
              <ColumnLayout columns={4} minColumnWidth={250}>
                <div style={{textAlign: "center"}}>
                  <b>Platform:</b> iRacing
                </div>
                <div style={{textAlign: "center"}}>
                  <b>Vehicle:</b> Ferrari 488 GT3 EVO 
                </div>
                <div style={{textAlign: "center"}}>
                  <b>Circuits:</b> Silverstone and Mount Panorama
                </div>
                <div style={{textAlign: "center"}}>
                  <b>Broadcast:</b> Live on&nbsp;
                  <Link 
                    href="https://youtu.be/ZozTIglo_p4?t=94"
                    target="_blank"
                  >
                    Racestars TV
                  </Link>
                </div>
              </ColumnLayout>
            </div>
            <div style={{maxWidth: "80%", justifyContent: "center", textAlign: "left"}}>
              <div style={{width: "100%", paddingTop: "0px"}}>
                <h4>Entries:</h4>
              </div>
              <div>
              All racers from the UK, Australia, and New Zealand are invited to compete in the
              pre-qualification session. Set the fastest time on the Suzuka International Circuit in our
              qualification servers for a chance to represent your nation in the NextLevel Racing
              Tri-Nations Esports Cup. Will you be among the elite drivers who secure their spot in the
              big event?<p />
              <b>Date:</b> 23rd and 30th July 2023<p />
              <b>Time:</b> 24hr servers, 9 am - 9 am your local time (BST, AEST, NZST)
              </div>
              <div style={{width: "100%", paddingTop: "20px"}}>
                <h4>Prizes Await the Victorious Racers</h4>
              </div>
              <Grid
                gridDefinition={[
                  { colspan: { default: 8, xs: 5, m: 5 } },
                  { colspan: { default: 8, xs: 5, m: 5 } },
                ]}
              >  
                <div style={{
                  height: "160px",
                }}>
                  <h5>Overall Winner:</h5>
                  <ul style={{color: awsui.colorTextBodyDefault}}>
                    <li>Next Level Racing Elite Lite Wheel Plate Edition</li>
                    <li>Next Level Racing ES1 Elite Seat</li>
                  </ul>
                </div>
                <div style={{
                  height: "160px",
                }}>
                <h5>Regional Awards (Each):</h5>
                <ul style={{color: awsui.colorTextBodyDefault}}>
                    <li>Next Level Racing GTTrack</li>
                  </ul>
                </div>
              </Grid>
              <Grid
                gridDefinition={[
                  { colspan: { default: 12, xs: 6 } },
                  { colspan: { default: 12, xs: 6 } },
                ]}
              >  
                <img 
                  src="/images/trinations/gt_track_gallery_1.png"
                  style={{
                    width: "100%"
                  }}
                />
                <img 
                  src="/images/trinations/gt_track_gallery_2.png"
                  style={{
                    width: "100%"
                  }}
                />
              </Grid>
              <div style={{width: "100%", paddingTop: "20px"}}>
                <h4>Details:</h4>
              </div>
              <div>
              Join the Next Level Racing Tri-Nations Esports Cup on iRacing!
              Presented by Motorsport UK, Motorsport Australia, and Motorsport New Zealand<p />
              <br />
              The Ultimate Virtual Racing Showdown!<p />
              The United Kingdom vs. Australia vs. New Zealand
              </div>
              <div style={{width: "100%", paddingTop: "20px"}}>
                <h5>The Battle for National Supremacy</h5>
              </div>
              <div>
              Immerse yourself in the heart-pounding action as RacestarsTV broadcasts every moment
              of this high-stakes event, presented by Motorsport UK, Motorsport Australia, and
              Motorsport New Zealand. The world will be watching as these three racing powerhouses
              collide on the virtual track.
              </div>
              <div style={{width: "100%", paddingTop: "20px"}}>
                <h5>Unleash Your Inner Speed Demon</h5>
              </div>
              <div>
              Only the Top 10 fastest drivers from each nation will earn the honour of representing
              their country in an exhilarating clash of skills and strategy. Witness the fierce competition
              as these elite racers go head-to-head on the renowned circuits of Mount Panorama and
              Silverstone, pushing the limits of speed and precision in the powerful Ferrari 488 GT3
              EVO.
              </div>
              <div style={{width: "100%", paddingTop: "20px"}}>
                <h5>Key Details:</h5>
              </div>
              <div>
                <ul style={{color: awsui.colorTextBodyDefault}}>
                  <li>Pre-Qualification Session: 23rd and 30th July at 9 am - 9 am</li>
                  <li>Tri-Nations Esports Cup: 6 August at 9 am BST</li>
                  <li>Circuits: Mount Panorama and Silverstone</li>
                  <li>Vehicle: Ferrari 488 GT3 EVO</li>
                  <li>Live Race Control</li>
                  <li>Manual Safety Car</li>
                  <li>Broadcast on&nbsp;
                    <Link
                      href="https://www.youtube.com/@RSTVAU" 
                      target="_blank"
                      fontSize="inherit"
                    >
                      RacestarsTV
                    </Link></li>
                </ul>
                Don't miss your chance to be a part of history! Represent your nation, showcase your
                skills, and claim victory in the Next Level Racing Tri-Nations Esports Cup, presented by the
                esteemed motorsport organizations of Motorsport UK, Motorsport Australia, and
                Motorsport New Zealand and driven by FRG E-SPORTS. Join us as we bring the spirit of
                motorsports to the digital realm.<p />
                <br />
                Register now and secure your spot among the elite racers!
              </div>
            </div>
          </div>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundItemSelected, padding: "50px"}}>
          <div className="body-content">
            <Box textAlign="center">
              <Link 
                // href="/signin"
                onFollow={ (event) => {
                  event.preventDefault();
                  // navigate(event.detail.href!)
                  setSeriesContent("register")
                  if (route !== 'authenticated') {
                    navigate("/signin")
                  }
                }}
              >
                <CustomButton
                  type="button"
                  onMouseEnter={ (event:any) => {
                    event.currentTarget.style.filter = `hue-rotate(110deg)`;
                  }}
                  onMouseLeave={ (event:any) => {
                    event.currentTarget.style.filter = "none";
                  }}
                  style={{
                    height: "80px", 
                    width: "50%", 
                    minWidth: "200px",
                    background: awsui.colorBackgroundNotificationRed, 
                    borderRadius: "2px", 
                    alignItems: "center", 
                    color: "white", 
                    fontWeight: "normal", 
                    fontSize: screenWidth_800 ? "24px" : "32px", 
                    borderWidth: "0",
                    lineHeight: "35px",
                  }}
                >
                  REGISTER NOW
                </CustomButton>
              </Link>
            </Box>
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundItemSelected, width: "100%", paddingTop: "20px", paddingBottom: "50px"}}>
          <div className="body-content">
            <div style={{
              maxWidth: screenWidth_1000 ? "100%" : "80%", 
              background: 
              awsui.colorBackgroundButtonPrimaryActive, 
              borderRadius: "20px"
            }}>
              <Grid
                gridDefinition={[
                  { colspan: { default: 8, xs: 5, m: 5 } },
                  { colspan: { default: 8, xs: 5, m: 5 } },
                ]}
              >  
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{color: awsui.colorTextButtonPrimaryActive, width: "100%", maxWidth: "300px", height: "480px", padding: "20px"}}>
                    <h5>Sunday 23rd and 30th July</h5> <p />
                    <b>9 AM</b> (Hosted session) <p />
                    <b>LONE QUALIFYING</b> (24 hours) <p />
                    <br />
                    Qualifying sessions for each nation with
                    the top 10 fastest times moving to the
                    race.<p />
                    <br />
                    {/* Competitors will receive a password for their nation's qualifying session after registration.<p /> */}
                    <p>Already registered? You can find out how to qualify&nbsp; 
                      <a 
                        onClick={() => setSeriesContent("qualifying")}
                        style={{
                          color: "lightblue"
                        }}
                      >
                        here
                      </a>.</p>
                      
                    <br />
                    * times are in your local timezone
                    United Kingdom BST
                    Australia AEST
                    New Zealand NZST
                  </div>
                </div>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{color: awsui.colorTextButtonPrimaryActive, width: "100%", maxWidth: "300px", height: "480px", padding: "20px"}}>
                    <h5>Sunday 6th August</h5> <p />
                    <b>8 AM BST</b> <p />
                    <b>PRACTICE</b> (20 Minutes) <p />
                    <br />
                    <b>8:20 AM BST</b> <p />
                    <b>OPEN QUALIFYING</b> (10 Minutes) <p />
                    <br />
                    <b>8:30 AM BST</b> <p />
                    <b>RACE 1</b> (30 Minutes) <p />
                    Mount Panorama Circuit
                    <br />
                    <b>9 AM BST</b> <p />
                    <b>PRACTICE</b> (20 Minutes) <p />
                    <br />
                    <b>9:20 AM BST</b> <p />
                    <b>OPEN QUALIFYING</b> (10 Minutes) <p />
                    <br />
                    <b>9:30 AM BST</b> <p />
                    <b>RACE 2</b> (30 Minutes) <p />
                    Silverstone Grand Prix Circuit
                    <br />
                  </div>
                </div>
              </Grid>
            </div>
          </div>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundContainerContent, paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px", paddingBottom: "20px" }}>
          <Grid
            gridDefinition={[
              { colspan: { default: 3, xs: 2, m: 1, l: 1 } },
              { colspan: { default: 4, xs: 4, m: 3 } },
              { colspan: { default: 4, xs: 4, m: 3 } },
              { colspan: { default: 4, xs: 4, m: 3 } },
              { colspan: { default: 4, xs: 4, m: 2 } },
            ]}
          > 
            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto"}}>
              <center>MEMBER OF</center>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/fia-logo-dark.png" : "/images/sponsor-logos/fia-logo-light.png"}
                alt="FIA"
                width="60%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto", padding: "0px 20px 0px 20px"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/ma-logo-dark.png" : "/images/sponsor-logos/ma-logo-light.png"}
                alt="Motorsport Australia"
                width="100%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto", padding: "0px 20px 0px 20px"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/motorsport-uk-logo-dark.png" : "/images/sponsor-logos/motorsport-uk-logo-dark.png"}
                alt="Motorsport UK"
                width="100%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto", padding: "0px 20px 0px 20px"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/motorsport-nz-banner-dark.png" : "/images/sponsor-logos/motorsport-nz-banner-dark.png"}
                alt="Motorsport NZ"
                width="100%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto", padding: "0px 20px 0px 20px"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/iracing-logo-dark.png" : "/images/sponsor-logos/iracing-logo-light.png"}
                alt="iRacing"
                width="100%"
              />
            </div>
            {/* <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto", padding: "0px 20px 0px 20px"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/frg-header-logo-dark.png" : "/images/sponsor-logos/frg-header-logo-light.png"}
                alt="Formula Racing Group"
                width="100%"
                />
            </div> */}
          </Grid>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundContainerContent, paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px", paddingBottom: "20px" }}>
        </div>
      </center>
    </>
  );
}

